export default __webpack_public_path__ + "static/media/YAS0010.34I-27179_-16417_0.a61831d0.jpg";